import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';
import { routes } from '@/routes';

export const useDashboardFeature = () => {
  const isNewDashboardEnabled = useFeatureFlag('new-dashboard');

  const getDashboardRoute = () =>
    isNewDashboardEnabled ? routes.physician.dashboard : routes.physician.dashboard;

  return {
    isNewDashboardEnabled,
    getDashboardRoute
  };
};
